// src/components/ScrollToTop.js
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to the top on every route change
    window.scrollTo(0, 0);
  }, [pathname]); // Triggers on route/path changes

  return null;
};

export default ScrollToTop;
